import z from 'zod';

import { getElementTypes } from '@@plate/utils/getElementTypes';

import { PlateTextElements, TextElementsCodec, UnityTextElements } from './Text';
import { CURRENT_VERSION, ElementId, UnityElementId, Version } from '../commons';
import { ELEMENT_TYPES } from '../constants';

export const UnityFooter = z.object({
    type: z.literal(ELEMENT_TYPES.FOOTER),
    elementId: UnityElementId,
    templateElement: z.boolean().optional(),
    version: Version,
    items: UnityTextElements,
});
export type UnityFooter = z.infer<typeof UnityFooter>;

export const PlateFooter = z.object({
    type: z.literal(ELEMENT_TYPES.FOOTER),
    id: ElementId,
    data: z
        .object({
            templateElement: z.boolean().optional(),
        })
        .optional(),
    children: PlateTextElements,
});
export type FooterElement = z.infer<typeof PlateFooter>;

export const FOOTER_ELEMENT_TYPES = getElementTypes([PlateFooter]);

export const FooterCodec = z.codec(UnityFooter, PlateFooter, {
    decode: (value) => ({
        type: value.type,
        id: value.elementId ?? crypto.randomUUID(),
        ...(value.templateElement ? { data: { templateElement: value.templateElement } } : {}),
        children: TextElementsCodec.decode(value.items),
    }),
    encode: (value) => ({
        type: value.type,
        elementId: value.id,
        version: CURRENT_VERSION,
        items: TextElementsCodec.encode(value.children),
        ...value.data,
    }),
});
